<template>
  <div id="app" :class="$store.state.menuIndex == 5 ? 'bg_gray' : false">
    <template v-if="isAntomPaymentRoute">
      <router-view :key="$route.fullPath" class="center-router"></router-view>
    </template>
    <template v-else>
      <HeaderH v-if="isMobile" />
      <Header v-else />
      <router-view :key="$route.fullPath" class="center-router"></router-view>
      <HomeCouponCampaignModal v-if="showHomeCouponModal" />
      <Footer />
    </template>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import HeaderH from "./components/HeaderH.vue";
import Footer from "./components/Footer.vue";
import HomeCouponCampaignModal from "./components/HomeCouponCampaignModal.vue";
import { getToken } from "@/utils/auth";
import { ensureSupportChatLoaded, isAntomPaymentRoute as checkAntomPaymentRoute, updateSupportChatUser } from "@/utils/support-chat";

export default {
  name: "App",
  components: {
    Header,
    HeaderH,
    Footer,
    HomeCouponCampaignModal,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    isAntomPaymentRoute() {
      return checkAntomPaymentRoute(this.$route);
    },
    showHomeCouponModal() {
      if (this.isAntomPaymentRoute) {
        return false;
      }
      // 使用 sessionStorage 确保同一浏览器 session 只弹出一次
      if (this.$route.path === "/" || this.$route.path === "/index") {
        const hasShownCouponModal = sessionStorage.getItem('homeCouponModalShown');
        if (hasShownCouponModal) {
          return false;
        }
        return true;
      }
      return false;
    },
    currentUserInfo() {
      return this.$store && this.$store.state && this.$store.state.user
        ? this.$store.state.user.userInfo
        : null;
    },
    currentUserId() {
      return this.currentUserInfo && this.currentUserInfo.id ? String(this.currentUserInfo.id) : "";
    },
  },
  mounted() {
    document.addEventListener("click", this.handleGlobalClick);
    this.syncSupportChat();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleGlobalClick);
  },
  watch: {
    $route() {
      document.documentElement.scrollTop = 0;
      this.syncSupportChat();
    },
    currentUserId() {
      this.syncSupportChat();
    },
  },
  created() {
    this.isMobile = window.matchMedia(
      "only screen and (max-width: 760px)"
    ).matches;
    this.$store.state.isMobile = this.isMobile;
    if (getToken()) {
      this.$store.dispatch("GetInfo").catch(() => {});
    }
  },
  methods: {
    async syncSupportChat() {
      if (this.isAntomPaymentRoute) {
        return;
      }
      try {
        await ensureSupportChatLoaded(this.$route);
        updateSupportChatUser(this.currentUserInfo);
      } catch (error) {
        console.error("Failed to initialize support chat:", error);
      }
    },
    handleGlobalClick(event) {
      const isUserIcon = event.target.closest('.user-container');
      const isLoginCard = event.target.closest('.login-card');

      if (isUserIcon || isLoginCard) {
        return;
      }

      this.$bus.$emit("close-login-card");
    },
  },
};

</script>
<style lang="scss">
#app {
  /* border: 1px solid red; */
  /* width: 100vw; */
  background: #f7f9f9;
  min-height: 100vh;
}
.bg_gray {
  background: #f7f9f9;
}
.nodata {
  padding-top: 100px;
  padding-bottom: 100px;
  img {
    display: block;
    margin: 0 auto;
  }
  p {
    padding: 40px 0 60px 0;
    color: #848484;
    font-size: 15px;
    text-align: center;
  }
  .btn {
    text-align: center;
    a {
      width: 225px;
      height: 47px;
      line-height: 47px;
      background: radial-gradient(
          0% 0% at 0% 0%,
          #ffffff 0%,
          #113dff 0%,
          #7123e7 0%
        ),
        #1d3fff;
      border-radius: 23px 23px 23px 23px;
      color: white;
      display: inline-block;
      font-weight: bold;
    }
  }
}
@media screen and (max-width: 500px) {
  .el-message-box {
    width: 300px !important;
  }

  .el-message {
    min-width: 80% !important; /* 璁剧疆鏈€灏忓搴︼紝閬垮厤澶獎 */
    width: auto !important; /* 瀹藉害鑷€傚簲 */
    max-width: 90% !important; /* 鏈€澶у搴?*/
    font-size: 14px; /* 璋冩暣瀛椾綋澶у皬 */
    padding: 10px; /* 璋冩暣鍐呰竟璺?*/
    margin-top: 8% !important;
  }

  .nodata {
    // scale: 0.9;
    padding-top: 25px;
    padding-bottom: 25px;
    img {
      display: block;
      width: 100%;
      scale: 0.6;
      margin: 0 auto;
    }
    p {
      padding: 20px 0 30px 0;
      color: #848484;
      font-size: 15px;
      text-align: center;
    }
    .btn {
      text-align: center;
      a {
        width: 225px;
        height: 47px;
        line-height: 47px;
        background: radial-gradient(
            0% 0% at 0% 0%,
            #ffffff 0%,
            #113dff 0%,
            #7123e7 0%
          ),
          #1d3fff;
        border-radius: 23px 23px 23px 23px;
        color: white;
        display: inline-block;
        font-weight: bold;
      }
    }
  }
}
</style>
